(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hy-stock-dispatch"] && !Shopify.designMode) return;
  try {
    function bindHyAvailability(root=document){
  root.querySelectorAll('[data-hy-availability]').forEach(panel=>{
    const section=panel.closest('.shopify-section')||document;
    const select=section.querySelector('#hy-variant');
    if(!select||panel.dataset.bound)return;
    panel.dataset.bound='true';
    const update=()=>{
      const template=panel.querySelector('template[data-hy-stock-variant="'+select.value+'"]');
      if(template)panel.querySelector('[data-hy-stock-status]').replaceChildren(template.content.cloneNode(true));
    };
    select.addEventListener('change',update);
    update();
  });
}
bindHyAvailability();
document.addEventListener('shopify:section:load',event=>bindHyAvailability(event.target));
  } catch(e) { console.error(e); }
})();

})();
